import { render, staticRenderFns } from "./CustomerStatusFilter.vue?vue&type=template&id=35dd3aee&scoped=true"
import script from "./CustomerStatusFilter.vue?vue&type=script&lang=ts"
export * from "./CustomerStatusFilter.vue?vue&type=script&lang=ts"
import style0 from "./CustomerStatusFilter.vue?vue&type=style&index=0&id=35dd3aee&prod&lang=scss&scoped=true"
import style1 from "./CustomerStatusFilter.vue?vue&type=style&index=1&id=35dd3aee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd3aee",
  null
  
)

export default component.exports